import { useCallback, useEffect, useState } from "react";

import { Button } from "@/components/ui/button/button";
import { ColorPicker } from "@/components/ui/color";

type Props = {
	optionId: string;
	text: string;
	color: string;
	// カラーの更新
	onUpdate: ({
		optionID,
		color,
		successCallback,
	}: {
		optionID: string;
		color: string;
		successCallback: () => void;
	}) => Promise<void>;
};

export const UpdateColor = ({ optionId, text, color: _color, onUpdate }: Props) => {
	const [color, setColor] = useState(_color);
	/**
	 * カラーの変更
	 */
	const onChangeColor = useCallback((value: string) => {
		setColor(value);
	}, []);

	/**
	 * カラーが変更されたか
	 */
	const [changed, setChanged] = useState(false);
	/**
	 * フラグの変更
	 */
	const onChangeChanged = useCallback((value: boolean) => {
		setChanged(value);
	}, []);
	useEffect(() => {
		/**
		 * 初期値と差分があれば変更フラグを立てる
		 */
		if (color !== _color) {
			onChangeChanged(true);
		}
	}, [_color, color, onChangeChanged]);

	/**
	 * カラーの更新
	 */
	const handleClickUpdateColor = useCallback(() => {
		const successCallback = () => onChangeChanged(false);
		onUpdate({ optionID: optionId, color, successCallback });
	}, [color, onChangeChanged, onUpdate, optionId]);

	return (
		<div className="col-span-1 flex items-center justify-between gap-x-3">
			<div className="flex h-10 items-center gap-x-3">
				<ColorPicker size="small" color={color} onChangeColor={onChangeColor} />
				<p className=" line-clamp-6">{text}</p>
			</div>

			<div className="shrink-0">
				{changed && (
					<Button variant="outline" type="button" size="default" onClick={handleClickUpdateColor}>
						保存
					</Button>
				)}
			</div>
		</div>
	);
};
